import searchActionTypes from "../actionsTypes/searchActionTypes";

const initialState = {
  searchResults: [],
  saveFormInputSearch: [],
};

const initSearchResulsts = (state, payload) => {
  return { ...state, searchResults: payload };
};

const saveInputSearch = (state, payload) => {
  return { ...state, saveFormInputSearch: payload };
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case searchActionTypes.INIT_SEARCHRESULTS:
      return initSearchResulsts(state, action.payload);
    case searchActionTypes.SAVE_FORM_INPUT_SEARCH:
      return saveInputSearch(state, action.payload);

    default:
      return state;
  }
};

export default searchReducer;
